import { Check } from 'lucide-react';

const features = [
  'Unlimited application forms',
  'Unlimited submissions',
  'Unlimited applicants',
  'Email campaigns',
  'Custom branding',
  'Resume & video uploads',
  'Calendly integration',
  'Indeed & LinkedIn ready',
  'Real-time notifications',
];

export default function Pricing() {
  return (
    <section id="pricing" className="section-padding bg-white">
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16 lg:mb-20">
          <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 rounded-full text-sm font-medium mb-4">
            Pricing
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            One plan.{' '}
            <span className="gradient-text">Everything included.</span>
          </h2>
          <p className="text-lg text-gray-600">
            No tiers, no feature gates, no surprises. Try free for 14 days.
          </p>
        </div>

        {/* Single Pricing Card */}
        <div className="max-w-lg mx-auto">
          <div className="relative rounded-2xl p-8 bg-gradient-to-b from-primary-600 to-primary-700 text-white shadow-lg shadow-primary-600/20">
            {/* Plan Header */}
            <div className="text-center mb-8">
              <h3 className="text-xl font-bold text-white mb-2">iHireFast Pro</h3>
              <p className="text-sm text-primary-100">
                Everything you need to hire faster
              </p>
              <div className="mt-4">
                <span className="text-5xl font-bold text-white">$25</span>
                <span className="text-primary-200">/month</span>
              </div>
              <p className="text-sm text-primary-200 mt-2">
                14-day free trial &middot; Cancel anytime
              </p>
            </div>

            {/* Features */}
            <ul className="space-y-4 mb-8">
              {features.map((feature, index) => (
                <li key={index} className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-5 h-5 rounded-full bg-primary-500 flex items-center justify-center">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-primary-50">{feature}</span>
                </li>
              ))}
            </ul>

            {/* CTA */}
            <a
              href="/app"
              className="block w-full text-center py-3 px-6 rounded-lg font-semibold transition-colors bg-white text-primary-600 hover:bg-primary-50"
            >
              Start Your 14-Day Free Trial
            </a>
          </div>
        </div>

        {/* Note */}
        <div className="mt-16 text-center">
          <p className="text-gray-600">
            No credit card required to start.{' '}
            <a href="mailto:support@ihirefast.com" className="text-primary-600 font-medium hover:underline">
              Questions? Contact us
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
